<script>
    import MultiSelect from "../../MultiSelect.svelte";

    export let propsForForm;
    let newTitle = '';

    $: feedSource = propsForForm && propsForForm[0];
    $: tagNames = propsForForm && propsForForm.length > 1 && propsForForm[1];
    $: close = propsForForm && propsForForm.length > 2 && propsForForm[2];
    $: title = feedSource && feedSource.title;

    $: currentTitle = newTitle || title;

    $: tagOptions = tagNames.map(tagName => ({ id: tagName, name: tagName }));
    $: initialItemTags = feedSource.tags;

    let itemTagIDs = [];

    async function saveSource() {
        let response = await fetch('/api/v1/user-source/save', {
            method: 'POST',
            body: JSON.stringify({
                title: currentTitle,
                tags: (itemTagIDs || []).map(tag => tag.startsWith('+') ? `#${tag.substring(1)}` : tag),
                feedSourceID: feedSource.feedSourceID,
            }),
        });

        await response.json();

        close();
    }

    function handleTitleChange(value) {
        newTitle = value;
    }
</script>

<div>
        <input
            bind:value={currentTitle}
            on:change={e => handleTitleChange(e.target.value)}
            class="input"
            type="text"
            name="source-title"
            autocomplete="off"
            placeholder="title"
            data-required="true" required
        />
        <MultiSelect id='item-tag-multiselect'
            bind:value={itemTagIDs}
            canAddNewOptions={true}
            initialValue={initialItemTags}
            placeholder="add tags"
        >
            <option selected="false" style='display: none' hidden disabled value=""></option>
            {#each tagOptions as tag}
                <option value={tag.id}>{tag.name}</option>
            {/each}
        </MultiSelect>
    <form id="edit-source-form">
        <button on:click|preventDefault={() => saveSource()} type="submit" form="edit-source-form" class="primary-red">
            Save
        </button>
    </form>
</div>

<style>
    input, button {
        width: 100%;
    }
</style>